import { useParams } from "react-router-dom";
import { DEFAULT_LOCALE, isSupportedLocale } from "./config";

export const useLocale = () => {
  const { locale } = useParams();
  if (locale && isSupportedLocale(locale)) {
    return locale;
  }
  return DEFAULT_LOCALE;
};
